<div class="modal fade" id="createRoomModal" tabindex="-1" aria-labelledby="createModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5 text-white" id="createModalLabel">Create Room</h1>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body text-white">
                <form [formGroup]="arenaForm">
                    <div class="row">
                        <div class="col-md-6 col-sm-12"></div>
                        <div class="col-md-6 col-sm-12"></div>
                    </div>
                    <div class="form-floating mb-3">
                        <input formControlName="title" class="form-control" placeholder="Arena Title" />
                        <label>Title</label>
                    </div>

                    <div class="form-floating mb-3">
                        <textarea formControlName="description" style="height: 100px;" class="form-control"
                            placeholder="Arena Description"></textarea>
                        <label>Description</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="password" formControlName="password" class="form-control" placeholder="Password" />
                        <label>Password</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" formControlName="isPublic" id="isPublicCheck" />
                        <label class="form-check-label cursor-pointer" for="isPublicCheck">Public</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" formControlName="isStatic" id="isStaticCheck" />
                        <label class="form-check-label cursor-pointer" for="isStaticCheck">Static</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" formControlName="hasVoice" />
                        <label class="form-check-label">Voice</label>
                    </div>

                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" formControlName="hasVideo" />
                        <label class="form-check-label">Video</label>
                    </div>

                    <div class="form-check form-check-inline mb-3">
                        <input type="checkbox" class="form-check-input" formControlName="hasImages" />
                        <label class="form-check-label">Images</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" formControlName="motd" class="form-control"
                            placeholder="Message of the Day" />
                        <label>Message of the Day</label>
                    </div>

                    <div class="form-floating mb-3">
                        <input type="text" formControlName="url" class="form-control"
                            placeholder="Optional URL" />
                        <label>Optional URL</label>
                    </div>

                    <div class="dropdown">
                        <button class="btn btn-xl btn-outline-primary dropdown-toggle" type="button" id="iconDropdownButton"
                            [class.is-invalid-icon]="arenaForm.controls.avatarURL.invalid && arenaForm.controls.avatarURL.touched"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            @if(selectedIcon()) {
                            <img src="{{arenaSignal().avatarURL}}" class="me-2" width="64" height="64"
                                alt="Selected Icon" />
                            }@else{
                                <img src="/images/logo_1_2.png" class="me-2" width="64" height="64"
                                alt="Default Icon" />
                            }
                            {{ selectedIcon() ? 'Change Icon' : 'Select Icon' }}
                        </button>

                        @if(arenaForm.controls.avatarURL.invalid && arenaForm.controls.avatarURL.touched) {
                        <div class="small text-danger mt-2">
                            Please select a room icon.
                        </div>
                        }

                        <ul class="dropdown-menu bg-dark text-white p-2" aria-labelledby="iconDropdownButton"
                            style="max-height: 300px; overflow-y: auto;">
                            @if(arenaIcons().length > 0) {
                            @for(icon of arenaIcons(); track $index) {
                            <li class="text-white">
                                <a class="dropdown-item d-flex align-items-center" (click)="selectIcon(icon)"
                                    style="cursor: pointer;">
                                    <img src="https://usercontent.h5arena.com/arenas/{{icon.guid}}{{icon.fileExtension}}" width="64" height="64" class="me-2" />
                                    {{icon.title ? icon.title: "No Title"}}
                                </a>
                            </li>
                            }
                            } @else {
                            <li class="text-white-50 px-3 py-2 small text-center">No uploaded icons available</li>
                            }
                        </ul>
                    </div>

                    <!--<pre>{{ arenaSignal() | json }}</pre>-->
                </form>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="create()">Create Room</button>
            </div>
        </div>
    </div>
</div>